import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { AuthProvider } from "./hooks/AuthProvider";
import { AppRoutes } from "./routes/AppRoutes";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { NotificationProvider } from "./hooks/NotificationProvider";
import { theme } from './theme';



function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AuthProvider>
            <NotificationProvider>
              <ErrorBoundary>
                <AppRoutes />
              </ErrorBoundary>
            </NotificationProvider>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
export default App;
